var _clipPath, _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLausanneStudentsChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 493 239",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "lausanne-students-charts",
    x: 0,
    y: 0.705,
    width: 492.754,
    height: 238.049,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.529,
    y: 6.139,
    width: 484.5,
    height: 231.483
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "68.712px",
    y: "234.257px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "High School"), /*#__PURE__*/React.createElement("text", {
    x: "185.15px",
    y: "234.257px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "Univ", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: "207.588px ",
    y: "234.257px "
  }, "e")), "rsity"), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-24.4712,-263.111)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "293.949px",
    y: "497.369px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "Appr", _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: "317.973px ",
    y: "497.369px "
  }, "e")), "nticesh"), /*#__PURE__*/React.createElement("text", {
    x: "361.295px",
    y: "497.369px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "i"), /*#__PURE__*/React.createElement("text", {
    x: "363.9px",
    y: "497.369px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "p DU", _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: "387.781px ",
    y: "497.369px "
  }, "A"))), /*#__PURE__*/React.createElement("text", {
    x: "394.994px",
    y: "497.369px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "L"), /*#__PURE__*/React.createElement("text", {
    x: "412.711px",
    y: "497.369px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "V", _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: "419.202px ",
    y: "497.369px "
  }, "o")), "cational ", _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: "467.711px ",
    y: "497.369px "
  }, "t")), "ra"), /*#__PURE__*/React.createElement("text", {
    x: "481.864px",
    y: "497.369px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "i"), /*#__PURE__*/React.createElement("text", {
    x: "484.47px",
    y: "497.369px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "n"), /*#__PURE__*/React.createElement("text", {
    x: "490.994px",
    y: "497.369px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "i"), /*#__PURE__*/React.createElement("text", {
    x: "493.6px",
    y: "497.369px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "ng")), /*#__PURE__*/React.createElement("text", {
    x: "32.085px",
    y: "223.491px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "0"), /*#__PURE__*/React.createElement("text", {
    x: "9.395px",
    y: "188.723px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "5,", _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: "18.213px ",
    y: "188.723px "
  }, "0")), "00"), /*#__PURE__*/React.createElement("text", {
    x: "4.211px",
    y: "153.956px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "10", _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: "15.495px 18.014px ",
    y: "153.956px 153.956px "
  }, ",0")), "00"), /*#__PURE__*/React.createElement("text", {
    x: "4.4px",
    y: "119.189px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "15,", _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: "17.826px ",
    y: "119.189px "
  }, "0")), "00"), /*#__PURE__*/React.createElement("text", {
    x: "2.687px",
    y: "84.421px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "20", _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: "15.682px 18.201px ",
    y: "84.421px 84.421px "
  }, ",0")), "00"), /*#__PURE__*/React.createElement("text", {
    x: "2.876px",
    y: "49.654px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "25,", _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: "18.014px ",
    y: "49.654px "
  }, "0")), "00"), /*#__PURE__*/React.createElement("text", {
    x: "2.613px",
    y: "14.887px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "30", _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: "15.759px 18.278px ",
    y: "14.887px 14.887px "
  }, ",0")), "00"), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", null, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.089,
    y: 10.729,
    width: 441.12,
    height: 175.2,
    clipRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.888,185.359l440.141,-0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "0.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.888,150.591l440.141,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "0.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.888,115.824l440.141,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "0.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.888,81.057l440.141,-0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "0.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.888,46.289l440.141,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "0.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.888,11.522l440.141,-0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "0.67px"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.089,
    y: 219.289,
    width: 441.12,
    height: 1.68,
    clipRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.888,220.126l440.141,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "0.67px"
    }
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.888,
    y: 127.631,
    width: 103.728,
    height: 92.495
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.186,127.631l87.131,0c0.545,0 1.084,0.053 1.619,0.159c0.534,0.107 1.053,0.264 1.556,0.473c0.504,0.208 0.982,0.464 1.435,0.767c0.453,0.302 0.872,0.646 1.258,1.031c0.385,0.386 0.729,0.805 1.032,1.258c0.302,0.453 0.558,0.931 0.766,1.435c0.209,0.503 0.366,1.022 0.473,1.556c0.106,0.535 0.159,1.074 0.159,1.619l0,84.197c0,0.545 -0.053,1.085 -0.159,1.619c-0.107,0.534 -0.264,1.053 -0.473,1.557c-0.208,0.503 -0.464,0.981 -0.766,1.434c-0.303,0.453 -0.647,0.873 -1.032,1.258c-0.386,0.385 -0.805,0.729 -1.258,1.032c-0.453,0.302 -0.931,0.558 -1.435,0.767c-0.503,0.208 -1.022,0.366 -1.556,0.472c-0.535,0.106 -1.074,0.159 -1.619,0.159l-87.131,0c-0.545,0 -1.085,-0.053 -1.619,-0.159c-0.535,-0.106 -1.053,-0.264 -1.557,-0.472c-0.503,-0.209 -0.981,-0.465 -1.435,-0.767c-0.453,-0.303 -0.872,-0.647 -1.257,-1.032c-0.385,-0.385 -0.729,-0.805 -1.032,-1.258c-0.303,-0.453 -0.558,-0.931 -0.767,-1.434c-0.208,-0.504 -0.366,-1.023 -0.472,-1.557c-0.106,-0.534 -0.159,-1.074 -0.159,-1.619l-0,-84.197c-0,-0.545 0.053,-1.084 0.159,-1.619c0.106,-0.534 0.264,-1.053 0.472,-1.556c0.209,-0.504 0.464,-0.982 0.767,-1.435c0.303,-0.453 0.647,-0.872 1.032,-1.258c0.385,-0.385 0.804,-0.729 1.257,-1.032c0.454,-0.302 0.932,-0.558 1.435,-0.766c0.504,-0.209 1.022,-0.366 1.557,-0.473c0.534,-0.106 1.074,-0.159 1.619,-0.159Z",
    style: {
      fill: "#0496ff",
      fillRule: "nonzero"
    }
  })), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.025,
    y: 13.872,
    width: 103.728,
    height: 206.254
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.324,13.872l87.131,0c0.545,0 1.084,0.053 1.619,0.16c0.534,0.106 1.053,0.263 1.556,0.472c0.504,0.208 0.982,0.464 1.435,0.767c0.453,0.302 0.872,0.646 1.258,1.032c0.385,0.385 0.729,0.804 1.031,1.257c0.303,0.453 0.559,0.931 0.767,1.435c0.209,0.503 0.366,1.022 0.473,1.557c0.106,0.534 0.159,1.074 0.159,1.618l0,197.956c-0,0.545 -0.053,1.085 -0.159,1.619c-0.107,0.534 -0.264,1.053 -0.473,1.557c-0.208,0.503 -0.464,0.981 -0.767,1.434c-0.302,0.453 -0.646,0.873 -1.031,1.258c-0.386,0.385 -0.805,0.729 -1.258,1.032c-0.453,0.302 -0.931,0.558 -1.435,0.767c-0.503,0.208 -1.022,0.366 -1.556,0.472c-0.535,0.106 -1.074,0.159 -1.619,0.159l-87.131,0c-0.545,0 -1.085,-0.053 -1.619,-0.159c-0.535,-0.106 -1.054,-0.264 -1.557,-0.472c-0.503,-0.209 -0.982,-0.465 -1.435,-0.767c-0.453,-0.303 -0.872,-0.647 -1.257,-1.032c-0.385,-0.385 -0.729,-0.805 -1.032,-1.258c-0.303,-0.453 -0.558,-0.931 -0.767,-1.434c-0.208,-0.504 -0.366,-1.023 -0.472,-1.557c-0.106,-0.534 -0.16,-1.074 -0.16,-1.619l0,-197.956c0,-0.544 0.054,-1.084 0.16,-1.618c0.106,-0.535 0.264,-1.054 0.472,-1.557c0.209,-0.504 0.464,-0.982 0.767,-1.435c0.303,-0.453 0.647,-0.872 1.032,-1.257c0.385,-0.386 0.804,-0.73 1.257,-1.032c0.453,-0.303 0.932,-0.559 1.435,-0.767c0.503,-0.209 1.022,-0.366 1.557,-0.472c0.534,-0.107 1.074,-0.16 1.619,-0.16Z",
    style: {
      fill: "#0496ff",
      fillRule: "nonzero"
    }
  })), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 271.163,
    y: 117.646,
    width: 103.728,
    height: 102.48
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.462,117.646l87.131,-0c0.545,-0 1.084,0.053 1.619,0.159c0.534,0.107 1.053,0.264 1.556,0.472c0.504,0.209 0.982,0.465 1.435,0.767c0.453,0.303 0.872,0.647 1.257,1.032c0.386,0.386 0.73,0.805 1.032,1.258c0.303,0.453 0.559,0.931 0.767,1.434c0.209,0.504 0.366,1.023 0.472,1.557c0.107,0.535 0.16,1.074 0.16,1.619l-0,94.182c-0,0.545 -0.053,1.085 -0.16,1.619c-0.106,0.534 -0.263,1.053 -0.472,1.557c-0.208,0.503 -0.464,0.981 -0.767,1.434c-0.302,0.453 -0.646,0.873 -1.032,1.258c-0.385,0.385 -0.804,0.729 -1.257,1.032c-0.453,0.302 -0.931,0.558 -1.435,0.767c-0.503,0.208 -1.022,0.366 -1.556,0.472c-0.535,0.106 -1.074,0.159 -1.619,0.159l-87.131,0c-0.545,0 -1.085,-0.053 -1.619,-0.159c-0.535,-0.106 -1.054,-0.264 -1.557,-0.472c-0.503,-0.209 -0.982,-0.465 -1.435,-0.767c-0.453,-0.303 -0.872,-0.647 -1.257,-1.032c-0.385,-0.385 -0.729,-0.805 -1.032,-1.258c-0.303,-0.453 -0.558,-0.931 -0.767,-1.434c-0.209,-0.504 -0.366,-1.023 -0.472,-1.557c-0.107,-0.534 -0.16,-1.074 -0.16,-1.619l0,-94.182c0,-0.545 0.053,-1.084 0.16,-1.619c0.106,-0.534 0.263,-1.053 0.472,-1.557c0.209,-0.503 0.464,-0.981 0.767,-1.434c0.303,-0.453 0.647,-0.872 1.032,-1.258c0.385,-0.385 0.804,-0.729 1.257,-1.032c0.453,-0.302 0.932,-0.558 1.435,-0.767c0.503,-0.208 1.022,-0.365 1.557,-0.472c0.534,-0.106 1.074,-0.159 1.619,-0.159Z",
    style: {
      fill: "#0496ff",
      fillRule: "nonzero"
    }
  })), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 383.301,
    y: 193.981,
    width: 103.728,
    height: 26.145
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.599,193.981l87.132,0c0.544,0 1.084,0.053 1.618,0.159c0.535,0.107 1.054,0.264 1.557,0.473c0.504,0.208 0.982,0.464 1.435,0.767c0.453,0.302 0.872,0.646 1.257,1.032c0.386,0.385 0.73,0.804 1.032,1.257c0.303,0.453 0.559,0.931 0.767,1.435c0.209,0.503 0.366,1.022 0.472,1.556c0.107,0.535 0.16,1.074 0.16,1.619l-0,17.847c-0,0.545 -0.053,1.085 -0.16,1.619c-0.106,0.534 -0.263,1.053 -0.472,1.557c-0.208,0.503 -0.464,0.981 -0.767,1.434c-0.302,0.453 -0.646,0.873 -1.032,1.258c-0.385,0.385 -0.804,0.729 -1.257,1.032c-0.453,0.302 -0.931,0.558 -1.435,0.767c-0.503,0.208 -1.022,0.366 -1.557,0.472c-0.534,0.106 -1.074,0.159 -1.618,0.159l-87.132,0c-0.544,0 -1.084,-0.053 -1.618,-0.159c-0.535,-0.106 -1.054,-0.264 -1.557,-0.472c-0.504,-0.209 -0.982,-0.465 -1.435,-0.767c-0.453,-0.303 -0.872,-0.647 -1.257,-1.032c-0.386,-0.385 -0.73,-0.805 -1.032,-1.258c-0.303,-0.453 -0.559,-0.931 -0.767,-1.434c-0.209,-0.504 -0.366,-1.023 -0.472,-1.557c-0.107,-0.534 -0.16,-1.074 -0.16,-1.619l0,-17.847c0,-0.545 0.053,-1.084 0.16,-1.619c0.106,-0.534 0.263,-1.053 0.472,-1.556c0.208,-0.504 0.464,-0.982 0.767,-1.435c0.302,-0.453 0.646,-0.872 1.032,-1.257c0.385,-0.386 0.804,-0.73 1.257,-1.032c0.453,-0.303 0.931,-0.559 1.435,-0.767c0.503,-0.209 1.022,-0.366 1.557,-0.472c0.534,-0.107 1.074,-0.16 1.618,-0.16Z",
    style: {
      fill: "#0496ff",
      fillRule: "nonzero"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLausanneStudentsChart);
export default __webpack_public_path__ + "static/media/lausanne-students-chart.d7f60455e0f668803e5f1377c0c4629a.svg";
export { ForwardRef as ReactComponent };